module.exports = __webpack_public_path__ + "4c29a7484d60da7358390498cdf82193.fbx";